// project import
import dashboard from './dashboard';
import location from './location';
import identity from './identity';
import captains from './captains';
import restaurants from './restaurants';
import orders from './orders';
import finance from './finance';
import social from './social';
import content from './content';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, location, identity, captains, restaurants, orders, finance, social, content]
};

export default menuItems;
